// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { AsyncPipe, NgIf } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizedDatePipe } from 'src/app/modules/shared/pipes/localizedDate.pipe';
import { AnnouncementService } from '../../services/announcement-service';
import { FeatureDetailsService } from '../../services/feature-details.service';
import { UserService } from '../../services/user.service';
@Component({
  selector: 'app-user-documentation',
  templateUrl: './user-documentation.component.html',
  styleUrls: ['./user-documentation.component.css'],
  standalone: true,

  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [NgIf, AsyncPipe, LocalizedDatePipe, TranslateModule],
})
export class UserDocumentationComponent implements OnInit {
  isWhatsNewEnabled = false;
  constructor(
    protected userService: UserService,
    private featureDetailsService: FeatureDetailsService,
    private router: Router,
    protected announcementService: AnnouncementService,
  ) {}

  ngOnInit(): void {
    this.featureDetailsService.whatsNewConfig.lastSuccessfulData$.subscribe(
      (data) => (this.isWhatsNewEnabled = data.isWhatsNewEnabled ?? false),
    );
  }
  showWhatsNewModal(): void {
    this.featureDetailsService.showFeatureDetailsModal.next(true);
  }

  routeToReleaseNotes(): void {
    this.router.navigateByUrl('/releaseNotes');
  }
}
